import type { BoardCardField } from "@design-system/Board/Board.types";
import {
    PresenceStack,
    type PresenceStackMember,
} from "@components/avatar/PresenceStack";
import {
    TaskFieldControl,
    type TaskFieldEditor,
} from "./TaskBoardFieldControls";
import { taskFieldProps } from "./TaskChipButton";
import {
    getTaskPresenceMembers,
    type TaskPresence,
} from "./taskPresenceMembers";

/**
 * The card's presence stack, bottom right. With `editor` the assignee avatar
 * (or the empty slot) opens List's assignee picker anchored to it, as does
 * the A shortcut; the other avatars and the +N chip open the task. Without
 * (View-only, an assignee the task can't change, or a compact card) the
 * whole stack is plain, so a click opens the task.
 */
export const TaskCardPresence = ({
    members,
    editor,
}: {
    members: readonly PresenceStackMember[];
    editor?: TaskFieldEditor;
}) =>
    editor === undefined ? (
        <PresenceStack members={members} />
    ) : (
        <TaskFieldControl
            field="assignee"
            editor={editor}
            renderTrigger={(props) => (
                <PresenceStack
                    members={members}
                    assigneeButtonProps={{
                        ...props,
                        ...taskFieldProps("assignee"),
                        tabIndex: -1,
                    }}
                />
            )}
        />
    );

/** The card's bottom-right field holding its presence stack; `editor` as on `TaskCardPresence`. */
export const getTaskPresenceField = ({
    editor,
    ...presence
}: TaskPresence & {
    isAgentWorking: boolean;
    editor?: TaskFieldEditor;
}): BoardCardField => ({
    id: "presence",
    placement: "bottomEnd",
    content: (
        <TaskCardPresence
            members={getTaskPresenceMembers(presence)}
            editor={editor}
        />
    ),
});
